
import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'

export default Vue.extend({
  name: 'AppTip',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
  render(h, { props, children, data }) {
    return h(
      props.tag,
      mergeData(data, {
        staticClass: 'app-tip',
      }),
      children,
    )
  },
})
